<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card outlined :loading="isLoading">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-toolbar-title>Great! Check your Inbox</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-form>
          <v-card-text class="pb-0">
            <div class="text-center text-body-2 text--secondary">
              <p>
                We've emailed a verification code to
                <span class="font-weight-bold">{{ email }}</span>
              </p>
              <!-- <p>It will expire shortly so please verify soon.</p> -->
              <p>Remember to check your spam folder just in case.</p>
              <div class="d-flex flex-column justify-center align-center my-1">
                <OtpInput
                  ref="otpInput"
                  :input-classes="error ? 'error-input otp-input' : 'otp-input'"
                  separator="-"
                  v-model="otp"
                  :num-inputs="4"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-complete="handleComplete"
                  @on-change="handleComplete"
                />
                <div v-if="error" class="error--text text-caption mt-1">
                  {{ errorMessage }}
                </div>
              </div>

              <v-btn
                class="primary mt-3 mb-3"
                depressed
                width="250"
                large
                @click="handleSubmit"
                :disabled="otp.length != 4"
                >Submit</v-btn
              >

              <!-- <v-btn
                width="250"
                elevation="0"
                type="submit"
                color="primary"
                class="mt-16 px-5 mb-3 text-body-2"
                >Resend Email</v-btn
              > -->
            </div>
          </v-card-text>
          <v-card-actions class="d-block">
            <v-spacer />
            <div class="text-center text-caption text--secondary mb-4">
              Didn't receive a verification code ?
              <span
                class="
                  cursor-pointer
                  text-decoratioon-underline
                  font-weight-bold
                  black--text
                "
                @click.stop="handleRequestAgainClick"
                >Request again</span
              >
            </div>

            <div class="text-center text-body-2 text--secondary">
              <p class="mb-0">Need to change your email address?</p>
              <p
                @click="logoutUser()"
                class="font-weight-bold text-decoration-underline"
                style="cursor: pointer"
              >
                Please create a new account.
              </p>
            </div>

            <v-spacer />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
// @ is an alias to /src

import OtpInput from "@bachdgvn/vue-otp-input";
import { mapActions, mapGetters } from "vuex";
import {getAuth, getHttpsCallable} from "@/shared/firebase_utils";

export default {
  name: "VerifyEmail",
  data() {
    return {
      email: "",
      otp: "",
      error: false,
      errorMessage: "",
      isLoading: false,
    };
  },
  components: {
    OtpInput,
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    async sendVerificationEmail() {
      const auth = getAuth();
      //get the current user
      var user = auth.currentUser;
      // await user.sendEmailVerification();

      const sendOTPBasedVerificationEmail = getHttpsCallable("sendOTPBasedVerificationEmail");

      //Call the cloud function
      await sendOTPBasedVerificationEmail({
        uid: user.uid,
        email: user.email,
        firstName: this.userProfile.firstName,
      });
    },
    async logoutUser() {
      getAuth()
        .signOut()
        .then(() => {
          // Sign-out successful.
          this.$router.push("/register");
        })
        .catch(function (err) {
          // An error happened.
          console.log(err);
          this.$router.push("/register");
        });
    },
    async handleSubmit() {
      this.isLoading = true;
      const auth = getAuth();
      const user = auth.currentUser;
      // // await user.sendEmailVerification();
      const emailVerification = getHttpsCallable("emailVerification");
      // //Call the cloud function
      let result = await emailVerification({
        uid: user.uid,
        email: user.email,
        firstName: this.userProfile.firstName,
        otp: this.otp,
      });

      if (result.data.isSuccess) {
        this.isLoading = false;
        // Email address has been verified.
        // var user = firebase.auth().currentUser;
        // if (user) {
        //   console.log("user exists");
        //   // User is signed in.
        //   await user.reload();
        //   this.$router.push({
        //     name: "Dashboard",
        //     query: { emailVerfied: true },
        //   });
        // } else {
        //   console.log("user does not exist");
        //   // No user is signed in.
        //   this.$router.push({ name: "Login", query: { emailVerfied: true } });
        // }

        window.location.reload();
        // this.$router.push("/");
      } else {
        this.isLoading = false;
        this.otp = "";
        this.$refs.otpInput.clearInput();
        this.error = true;
        this.errorMessage = "Code is either invalid or has expired";
      }
    },
    handleComplete(inputOtp) {
      this.error = false;
      this.errorMessage = "";
      this.otp = inputOtp;
    },
    handleRequestAgainClick() {
      this.sendVerificationEmail();
      this.showSnackbar({ show: true, text: "OTP resent successfully!" });
    },
  },
  created() {
    //Set the users email
    this.email = getAuth().currentUser.email;
    this.sendVerificationEmail();
    // //Signout the users for now
    // firebase.auth().signOut().then(()=> {
    // // Sign-out successful.
    // }).catch(function(err) {
    // // An error happened.
    //     console.log(err);
    // });
  },
  computed: {
    ...mapGetters([
      "userProfile"
    ]),
  },
};
</script>
<style >
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.error-input {
  border: 1px solid red !important;
}
</style>
